export default __webpack_public_path__ + "static/media/ic_floki_40.70094103.png";